import { useEffect, useState } from 'react';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import styles from '../styles/Navbar.module.css';

const LINKS = [
  { label: 'About', id: 'about' },
  { label: 'Skills', id: 'skills' },
  { label: 'Services', id: 'services' },
  { label: 'Experience', id: 'experience' },
  { label: 'Work', id: 'projects' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    ScrollSmoother.get()?.paused(open);
    return () => {
      document.body.style.overflow = '';
      ScrollSmoother.get()?.paused(false);
    };
  }, [open]);

  const goTo = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
        <a href="#top" className={styles.logo} onClick={goTo('top')}>
          <span className={styles.logoDot} />
          YASEEN
        </a>

        <div className={`desk-only ${styles.links}`}>
          {LINKS.map((link) => (
            <a key={link.id} href={`#${link.id}`} onClick={goTo(link.id)}>
              {link.label}
            </a>
          ))}
          <a
            href="/Muhammad-Yaseen-CV.pdf"
            download
            className={styles.resumeBtn}
            aria-label="Download resume"
            title="Download resume"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 4v11m0 0-4-4m4 4 4-4M5 19h14" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <a href="#contact" onClick={goTo('contact')} className={styles.contactPill}>
            Contact
          </a>
        </div>

        <button type="button" className={`mob-only ${styles.burger}`} onClick={() => setOpen(true)} aria-label="Menu">
          <span />
          <span />
          <span />
        </button>
      </nav>

      {open && (
        <div className={styles.mobileMenu}>
          <button type="button" onClick={() => setOpen(false)} aria-label="Close" className={styles.closeBtn}>
            ×
          </button>
          {LINKS.map((link) => (
            <a key={link.id} href={`#${link.id}`} onClick={goTo(link.id)}>
              {link.label}
            </a>
          ))}
          <a href="/Muhammad-Yaseen-CV.pdf" download className={styles.mobileResume}>
            Download CV
          </a>
          <a href="#contact" onClick={goTo('contact')}>
            Contact
          </a>
        </div>
      )}
    </>
  );
}
